export default "__VITE_ASSET__Dtaax1Vi__"